/*
  Auto-bundle: when a product whose id is in LUYORS_AUTOBUNDLE.triggerProductIds
  is added to cart via /cart/add.js, also add LUYORS_AUTOBUNDLE.companionVariantId
  (max 1 per cart). Wraps window.fetch once so all 5+ add-to-cart code paths
  in this theme are covered by a single hook.

  Perf:
   - Non-cart-add fetches: regex test + early return (~0 cost).
   - Cart-add fetches that don't match the trigger: regex test + one JSON
     parse of the response body (~1 ms).
   - Cart-add for the trigger: +1 /cart.js + 1 companion /cart/add.js +
     1 DOM swap (~150-400 ms total extra latency).

  Recursion guard: the companion-add POST is tagged with the
  X-Luyors-Companion: 1 header; the wrapper short-circuits on requests
  carrying that header. No infinite loop.

  Concurrency guard: inFlight boolean prevents a second companion-add
  from kicking off while one is in progress (rapid-click protection).
*/
(function () {
  if (!window.LUYORS_AUTOBUNDLE) return;
  /* TRIGGERS: product_ids that should auto-add the companion. Prefer the
     triggerProductIds array; fall back to the legacy scalar triggerProductId
     so older cached pages keep working. */
  var TRIGGERS = window.LUYORS_AUTOBUNDLE.triggerProductIds;
  if (!Array.isArray(TRIGGERS)) {
    TRIGGERS = window.LUYORS_AUTOBUNDLE.triggerProductId
      ? [window.LUYORS_AUTOBUNDLE.triggerProductId]
      : [];
  }
  var COMPANION = window.LUYORS_AUTOBUNDLE.companionVariantId;
  if (!TRIGGERS.length || !COMPANION) return;

  var HEADER = 'X-Luyors-Companion';
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/i;
  var origFetch = window.fetch.bind(window);
  var inFlight = false;

  window.fetch = function (input, init) {
    init = init || {};
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    /* Early return — non-cart-add requests skip all extra logic. */
    if (!ADD_RE.test(url)) return origFetch(input, init);

    /* Skip recursion — our own companion-add calls tag themselves. */
    var hdrs = init.headers || {};
    var isCompanion =
      hdrs[HEADER] || hdrs[HEADER.toLowerCase()] ||
      (typeof hdrs.get === 'function' && hdrs.get(HEADER));
    if (isCompanion) return origFetch(input, init);

    return origFetch(input, init).then(function (response) {
      response.clone().json().then(function (data) {
        var items = Array.isArray(data && data.items)
          ? data.items
          : (data ? [data] : []);
        var triggerAdded = items.some(function (it) {
          return it && TRIGGERS.indexOf(it.product_id) !== -1;
        });
        if (!triggerAdded || inFlight) return;
        inFlight = true;

        origFetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var alreadyHas = cart.items.some(function (it) {
              return it.variant_id === COMPANION;
            });
            if (alreadyHas) return;
            return addCompanion();
          })
          .catch(function (e) { console.error('[auto-bundle]', e); })
          .finally(function () { inFlight = false; });
      }).catch(function () { /* non-JSON response — ignore */ });
      return response;
    });
  };

  function addCompanion() {
    var fd = new FormData();
    fd.append('id', COMPANION);
    fd.append('quantity', 1);
    fd.append('sections', 'cart-drawer,cart-bubble');
    fd.append('sections_url', window.location.pathname);
    var headers = { 'X-Requested-With': 'XMLHttpRequest' };
    headers[HEADER] = '1';
    return origFetch('/cart/add.js', {
      method: 'POST',
      headers: headers,
      body: fd,
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (state) { renderCartSections(state); });
  }

  function renderCartSections(state) {
    if (!state || !state.sections) return;
    [
      { id: 'Cart-Drawer', selector: '.cart-drawer', section: 'cart-drawer' },
      { id: 'cart-drawer-toggle', selector: '.thb-item-count', section: 'cart-bubble' }
    ].forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = state.sections[s.section];
      if (!host || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sourceNode = doc.querySelector(s.selector);
      if (!sourceNode) return;
      var target = host.querySelector(s.selector) || host;
      target.innerHTML = sourceNode.innerHTML;
    });

    /* Re-init drawer behaviors after innerHTML swap. Mirrors the
       theme's ProductCard.renderContents pattern at app.js:233-245 —
       without this, the drawer loses its scroll/drag bindings and
       the header icon bar de-syncs. */
    if (typeof CartDrawer !== 'undefined') {
      try { new CartDrawer(); } catch (e) { /* re-init is best-effort */ }
    }
    if (typeof initiateFlicktyInDrawer === 'function') {
      try { initiateFlicktyInDrawer(); } catch (e) {}
    }
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }
})();
